(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    const productJson = document.getElementById('product-json');
if (productJson) {
  const product = JSON.parse(productJson.textContent);
  const variants = {};
  product.variants.forEach(function(v) { variants[v.id] = v; });

  function updateStock(variantId) {
    const variant = variants[variantId];
    const stockEl = document.querySelector('.product-stock');
    if (!stockEl || !variant) return;

    if (variant.inventory_management !== 'shopify') {
      stockEl.style.display = 'none';
      return;
    }

    stockEl.style.display = 'block';
    const qty = variant.inventory_quantity;

    if (!variant.available) {
      stockEl.className = 'product-stock out-of-stock';
      stockEl.innerHTML = '❌ Agotado';
    } else if (qty <= 5) {
      stockEl.className = 'product-stock low-stock';
      stockEl.innerHTML = '⚠️ Últimas unidades';
    } else {
      stockEl.className = 'product-stock';
      stockEl.innerHTML = '✅ En stock';
    }
  }

  var lastVariantId = null;
  setInterval(function() {
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = parseInt(urlParams.get('variant'));
    if (variantId && variantId !== lastVariantId) {
      lastVariantId = variantId;
      updateStock(variantId);
    }
  }, 300);
}
  } catch(e) { console.error(e); }
})();

})();
